import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb1d7be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-card" }
const _hoisted_2 = { class: "mb-2" }

import {ref, watch, PropType} from "vue";
import {UserBlacklistComment} from "@/models/blacklisting/UserBlacklistHistorique";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlacklistingCommentTable',
  props: {
    data: {
        type: Array as PropType<UserBlacklistComment[]>,
        required: true,
    },
},
  setup(__props) {

const props = __props;


const paginator = ref<boolean>(false);
const tableData = ref(sortCommentsByDate(RemoveEmpty(props.data)));
const nbComments = ref(tableData.value.length);

watch(
    () => props.data,
    (newVal) => {
        tableData.value = sortCommentsByDate(RemoveEmpty(newVal));
        nbComments.value = tableData.value.length;
    }
);


if (nbComments.value > 10) {
    paginator.value = true;
}

function RemoveEmpty(data: UserBlacklistComment[]): UserBlacklistComment[] {
    return data.filter((item: UserBlacklistComment) => item.comment !== "");
}

function sortCommentsByDate(comments: UserBlacklistComment[]) {
    function parseFrenchDate(dateStr: string): Date {
        const format = "DD/MM/YYYY HH[h]mm";
        const date = moment(dateStr, format);
        return date.toDate();
    }

    return comments.sort(
        (a, b) =>
            parseFrenchDate(b.date).getTime() - parseFrenchDate(a.date).getTime()
    );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(nbComments.value) + " commentaire" + _toDisplayString(nbComments.value > 1 ? 's' : ''), 1),
    _createVNode(_unref(DataTable), {
      value: tableData.value,
      paginator: paginator.value,
      rows: 10
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), { headerStyle: "width: 1rem" }),
        _createVNode(_unref(Column), {
          field: "date",
          header: "Date"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("span", null, _toDisplayString(slotProps.data.date), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "by",
          header: "Par"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("span", null, _toDisplayString(slotProps.data.createdBy), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "comment",
          header: "Commentaire"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("span", null, _toDisplayString(slotProps.data.comment), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "paginator"])
  ]))
}
}

})